module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-next-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-skip/btn-next-up@1x.png
// module id = 91
// module chunks = 0